export class MixpanelStore {
  static enabled = false;
}
